import { useMemo } from 'react';

import { useLinkToExplorer } from './links';
import { useUrlProjectParams } from './params';

export const useCommonLineageEntries = (projectName: string) => {
  const getProjectLink = useLinkToExplorer('project');
  const projectScope = useUrlProjectParams();

  return useMemo(() => {
    return [
      {
        key: 'Project',
        data: projectName,
        link: getProjectLink(projectScope),
      },
    ];
  }, [projectScope, getProjectLink, projectName]);
};
